import { useState } from "react";
import { url } from "../utils/config.js";
import postData from "../custom_functions/postData.js";
import { toast } from "react-toastify";
import { btnCancel, btnOne, modalContainer, } from "../utils/style.js";
import { formatDate, } from "../helperFunctions/estimateCalculation.js";
import formatNumberToUs from "../custom_functions/formatNumberToUs.js";
import Loader from "../reusable_components/Loader.jsx";

function FleetStatementPreview({ setShowPreview, selectedRows, setSelectedRows, setReloadTable, reloadTable, }) {
    const [loader, setLoader] = useState(false);

    const generateStatement = () => {
        setLoader(true)

        const selectedIds = selectedRows.map(row => row.id);
        const fleetCustomer = selectedRows[0].fleet_customer;

        postData(`${url}/generate_fleet_statement`, { invoiceIds: selectedIds, fleetCustomer }, (error) => {
            toast.error(error.response.data.message, { autoClose: 3000 })
            setLoader(false)
        }, (data) => {
            toast.success(data.message, { autoClose: 3000 })
            setSelectedRows([]);
            setReloadTable(!reloadTable);
            setShowPreview(false)
            setLoader(false)
        })
    }


    return (
        <div className={modalContainer}>
            <div className="bg-white rounded-lg p-4 w-2/3 overflow-y-scroll max-h-full">
                <div className={`text-sm text-center font-semibold text-gray-800 mb-4`}> Payment Summary</div>
                <div>
                    <div className="flex flex-row justify-between mb-4 border border-gray-300 bg-gray-50 rounded-md p-4 shadow-sm">
                        <div className="space-y-1 text-xs text-gray-700">
                            <p><span className="font-semibold">Customer Name:</span> {selectedRows[0]?.fleet_customer.name}</p>
                            <p><span className="font-semibold">Email:</span> {selectedRows[0]?.fleet_customer.email}</p>
                            <p><span className="font-semibold">Phone:</span> {selectedRows[0]?.fleet_customer.phone}</p>
                            <p><span className="font-semibold">Address:</span> {selectedRows[0]?.fleet_customer.address}</p>
                        </div>
                        <div className="space-y-1 text-xs text-gray-700 mr-4">
                            <p><span className="font-semibold">City:</span> {selectedRows[0]?.fleet_customer.city}</p>
                            <p><span className="font-semibold">{selectedRows[0]?.fleet_customer.country === "Canada" ? "Province:" : "State:"}</span> {selectedRows[0]?.fleet_customer.state_province}</p>
                            <p><span className="font-semibold">{selectedRows[0]?.fleet_customer.country === "Canada" ? "Postal Code:" : "Zip Code:"}</span> {selectedRows[0]?.fleet_customer.postal_code}</p>
                            <p><span className="font-semibold">Country:</span> {selectedRows[0]?.fleet_customer.country}</p>
                        </div>
                    </div>
                    <table className='w-full mb-4 text-xs text-center'>
                        <thead>
                            <tr className="bg-customTwo text-black font-semibold text-xs">
                                <th className="px-4 py-1 border border-gray-300">Invoice Id</th>
                                <th className="px-4 py-1 border border-gray-300">Invoice Date</th>
                                <th className="px-4 py-1 border border-gray-300">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedRows.map((estimate, index) =>
                                <tr key={index}>
                                    <td className="px-4 py-1 border border-gray-200">{`INV0000${estimate.id}`}</td>
                                    <td className="px-4 py-1 border border-gray-200">{formatDate(estimate.date)}</td>
                                    <td className="px-4 py-1 border border-gray-200">{`$${formatNumberToUs(estimate.cost / 100)}`}</td>
                                </tr>
                            )}
                            <tr key={selectedRows.length} >
                                <td colSpan="2" className="px-4 py-1 border border-gray-200 font-semibold text-right">Total</td>
                                <td className="px-4 py-1 border border-gray-200 font-semibold">{`$${formatNumberToUs(selectedRows.reduce((sum, estimate) => sum + estimate.cost / 100, 0))}`}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="flex justify-between px-16 gap-8 mt-6">
                    <button onClick={() => { setShowPreview(false); setLoader(false) }} className={btnCancel}>Cancel</button>
                    <button className={btnOne} onClick={() => generateStatement()} disabled={loader}>
                        <span className="flex gap-2 justify-center">Send Summary{loader && <Loader />}</span>
                    </button>
                </div>
            </div>
        </div >
    )

}

export default FleetStatementPreview;